/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./LandingPage.css";

import { useHistory, useRouteMatch } from "react-router-dom/cjs/react-router-dom";
import checkBrowserSupport from "../self-assesment/browserDetect";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";
export const Header = ({ setShowMemberBlockScreen = false, onTryMyraClick }) => {
  const location = useLocation();
  const { url } = useRouteMatch();
  const history = useHistory();
  const isActive = (path) => location.pathname === path;
  const handleMeberLoginClick = () => {
    const check = checkBrowserSupport("member");
    if (!check.isSupported) {
      // Render block screen instead of continuing
      setShowMemberBlockScreen(true);
      return;
    }

    if (window.isStartedLandingFlow) {
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();

        // Completely destroy the VoiceService instance
        VoiceService.destroyMyraCompletely(false);
        // Clear global references
        window.mayraCode = null;
        window.startFlow = null;
        window.currentCommandsAudio = {};
      }
      sessionStorage.removeItem("voiceService_wasListening");
      sessionStorage.removeItem("voiceService_currentFlow");
    }

    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }

    window.isThisFromHomeScreen = false;

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) loader.style.display = "flex";
        const loaderText = loader.querySelector("#loader-text");
        if (loaderText) loaderText.textContent = "Loading application...";
      }
      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");

      window.doNextLocation = history;
      document.querySelector("html").classList = [];

      setTimeout(() => {
        window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to="/" className="logo-text">
		  <img src="/images/healthlogo1.svg" alt=" " class="nav_logo" width="155" height="35" />
        </Link>
        <nav className="nav-links">
          <Link to={`/about`} className={`nav-link ${isActive("/about") ? "active" : ""}`}>
            About Us
          </Link>
          <Link to={`/contact-us`} className={`nav-link ${isActive("/contact") ? "active" : ""}`}>
            Contact Us
          </Link>
        </nav>
        <div className="header-ctas">
          <button className="header-login" rel="noopener noreferrer" onClick={handleMeberLoginClick}>
            Member Login
          </button>
          <button onClick={onTryMyraClick} className="header-try-btn" rel="noopener noreferrer">
            Try Myra Free
          </button>
        </div>
      </div>
    </header>
  );
};
